export const Setup = (function () {

  var init =  function ( ) { 

      // Add an event listner to prevent POSTing the data to the url on a PDS form field
      $('.pds-form').each(function () {
        this.addEventListener("submit", function(e){e.preventDefault()}, false);
      });

      // Get the element which stores the MydexID and whether we should run InApp DS
      var element = document.getElementById('myds-setup-data');
      // Stop executing if the element was not found.
      if(!element){
        return;
      }
      var setUpInappDS = element.getAttribute('data-inapp');
      var landingPage = element.getAttribute('data-landingPage');

      var callback;
      // IF InApp client list needs to be provisioned
      // Define the callback that is executed if the Validation passes
      if( setUpInappDS ){
        callback = function () {
            $('#loading').show();
            ClientList.provision().then(function(){
                    window.location = landingPage;
            });
        };
      }else{
        callback = function () {
          window.location = landingPage;
        };
      }
      // Validate all the required fields on the form
      Validation.validate(callback);
  };
  

  return {
    init: init
   }

}());


